var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{staticClass:"base-search-input",attrs:{"value":_vm.$props.value,"placeholder":"Search","size":"sm"},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }